import {
  Table, TBody, THead, Tr, Th, Td,
} from './Table';

export {
  Table, TBody, THead, Tr, Th, Td,
};
